import React from "react";
import Helmet from "react-helmet";

const HelmetWithGoogle = ({ verificationCodes = [] }) => (
  <Helmet>
    {verificationCodes.map(code => (
      <meta name="google-site-verification" content={code} key={code} />
    ))}
  </Helmet>
);

export default HelmetWithGoogle;
